import { Button } from 'antd';
import { Link } from 'react-router';
import { dispatchPaths } from '../../dispatch/dispatch.paths';
import { AbortTripAction } from '../../dispatch/public/AbortTripAction';
import { useTripPermissions } from '../hooks/use-trip-permissions';
import { availableTripActions } from '../policies/trip-actions.policy';
import { tripPaths } from '../trips.paths';
import type { TripPageData } from '../trips.api';

/** What the user can do from the page, by permission and by where the trip is. The server decides again on every call. */
export function TripActions({ trip, onChanged }: { trip: TripPageData; onChanged: () => void }) {
  const permissions = useTripPermissions();
  const actions = availableTripActions({ status: trip.status, hasDriver: trip.driver !== null, ...permissions });

  return (
    <div className="flex flex-wrap gap-2">
      {actions.includes('message') && (
        <Link to={tripPaths.tripTab(trip.id, 'messages')}>
          <Button>Message driver</Button>
        </Link>
      )}
      {actions.includes('capture') && (
        <Link to={tripPaths.tripTab(trip.id, 'record')}>
          <Button>Record for driver</Button>
        </Link>
      )}
      {actions.includes('reassign') && (
        <Link to={dispatchPaths.assignTrip(trip.id)}>
          <Button>Change crew</Button>
        </Link>
      )}
      <AbortTripAction tripId={trip.id} tripStatus={trip.status} canDispatch={permissions.canDispatch} onAborted={onChanged} />
    </div>
  );
}
